import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { AlertSettingsFacade } from '../../../../../Facades/Settings/alert-settings.facade';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [MatIconModule, TranslateModule, AvEmptyStateComponent, AvStatusChipComponent],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class SettingsComponent {
  readonly facade = inject(AlertSettingsFacade);

  kindLabelKey(kind: string): string {
    return `backoffice.settings.alert_kind.${kind}`;
  }

  kindDescriptionKey(kind: string): string {
    return `backoffice.settings.alert_description.${kind}`;
  }

  reload(): void {
    this.facade.reload();
  }
}
